module.exports = __webpack_public_path__ + "img/convertkit.b4cb6bd9.png";